<template lang="pug">
  form.form
    h3.form-title.text-center ส่วนที่ 3 :  ทักษะทางภาษาและทักษะพิเศษอื่นๆ


    h4.form-subtitle ทักษะทางภาษา (Knowledge Of Languages) เลือก "ดี"  "พอใช้"  หรือ  "ปรับปรุง"ตามระดับทักษะของคุณ

    .language-skills
      table
        thead
          tr
            th ภาษา
            th ฟัง/Listening				     			                   			                      	
            th พูด/Speaking
            th อ่าน/Reading
            th เขียน/Writing
            th(v-if="skills.language.length > 2") #
        tbody
          tr(
            v-for="(language, index) in skills.language"
            :key="index"
          )
            td
              label(v-if="language.default") {{ language.title }}

              validation-provider(
                v-else
                v-slot="{ errors, valid }"
                rules="required"
                name="ภาษา"
              )
                input.form-control(
                  :id="`level${index}`"
                  :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                  type="text"
                  placeholder="ระบุภาษา"
                  v-model="language.title"
                  @input="onChange"
                )
                span.invalid-feedback {{ errors[0] }}

            td
              validation-provider(
                v-slot="{ errors, valid }"
                rules="required"
                name="listening"
              )
                select.custom-select(
                  :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                  v-model="language.listening"
                  @change="onChange"
                )
                  option(value="" disabled) เลือกระดับ
                  option(
                    v-for="(value, index) in level"
                    :key="index"
                    :value="value"
                  ) {{ value }}

                span.invalid-feedback {{ errors[0] }}
                
            td
              validation-provider(
                v-slot="{ errors, valid }"
                rules="required"
                name="speaking"
              )
                select.custom-select(
                  :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                  v-model="language.speaking"
                  @change="onChange"
                )
                  option(value="" disabled) เลือกระดับ
                  option(
                    v-for="(value, index) in level"
                    :key="index"
                    :value="value"
                  ) {{ value }}
                span.invalid-feedback {{ errors[0] }}

            td
              validation-provider(
                v-slot="{ errors, valid }"
                rules="required"
                name="reading"
              )
                select.custom-select(
                  :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                  v-model="language.reading"
                  @change="onChange"
                )
                  option(value="" disabled) เลือกระดับ
                  option(
                    v-for="(value, index) in level"
                    :key="index"
                    :value="value"
                  ) {{ value }}
                span.invalid-feedback {{ errors[0] }}

            td
              validation-provider(
                v-slot="{ errors, valid }"
                rules="required"
                name="writing"
              )
                select.custom-select(
                  :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                  v-model="language.writing"
                  @change="onChange"
                )
                  option(value="" disabled) เลือกระดับ
                  option(
                    v-for="(value, index) in level"
                    :key="index"
                    :value="value"
                  ) {{ value }}
                span.invalid-feedback {{ errors[0] }}

            td(v-if="skills.language.length > 2")
              button.language-remove(
                v-if="!language.default"
                @click="remove($event, index)"
              ) ลบ
        tfoot
          tr
            td(colspan="4")
            td(
              :colspan="skills.language.length > 2 ? 2 : 0"
            )
              button.language-add(@click="generate") + เพิ่มทักษะทางภาษา

    .form-subtitle  ทักษะพิเศษอื่นๆ (Special Abilities)

    .form-item.has-bg
      .row
        label.col-sm-5(
          for="driverศicense"
        ) 1. ท่านมีใบอนุญาติขับขี่หรือไม่

        .col-sm-7
          .custom-control.custom-checkbox.custom-control-inline
            input.custom-control-input#carDriverLicense(
              type="checkbox"
              value="มีใบขับขี่รถยนต์"
              v-model="skills.driver_license"
              @change="onChange"
            )
            label.custom-control-label(for="carDriverLicense") มีใบขับขี่รถยนต์

          .custom-control.custom-checkbox.custom-control-inline
            input.custom-control-input#motorcycleDriverLicense(
              type="checkbox"
              value="มีขับขี่รถจักรยานยนต์"
              v-model="skills.driver_license"
              @change="onChange"
            )
            label.custom-control-label(for="motorcycleDriverLicense") มีขับขี่รถจักรยานยนต์

    .form-item
      .row
        label.col-sm-5(for="computer") 2.ความสามารถทางคอมพิวเตอร์ / Computer Skills

        .col-sm-7
          .form-group
            textarea.form-control#computer(
              rows="4"
              v-model="skills.computer"
              @input="onChange"
            )

    .form-item.has-bg
      .row
        label.col-sm-5(for="hobbies") 3.งานอดิเรก / กิจกรรมที่สนใจ Hobbies

        .col-sm-7
          .form-group
            textarea.form-control#hobbies(
              rows="4"
              v-model="skills.hobbies"
              @input="onChange"
            )


    .form-item
      .row
        label.col-sm-5(for="additional") 4.ความชำนาญด้านอื่น / Additional Skills

        .col-sm-7
          .form-group
            input.form-control#additional(
              type="text"
              rows="4"
              v-model="skills.additional"
              @input="onChange"
            )

    .form-footer
      .d-flex.justify-content-center
        button.back(@click="$store.commit('SET_STEP', 2)") กลับสู่ก่อนหน้า
        button.next(type="submit" @click="$store.commit('SET_STEP', 4)") บันทึกและไปขั้นต่อไป
</template>
<script>
import { mapState } from 'vuex'
export default {
  data: () => ({
    level: ['ดี', 'พอใช้', 'ปรับปรุง'],
  }),

  computed: {
    ...mapState(['skills'])
  },

  methods: {
    generate(){
      this.skills.language.push({
        title: '',
        listening: '',
        speaking: '',
        reading: '',
        writing: '',
        default: false,
      });

      this.$store.commit('SET_SKILLS', this.skills)
    },

    remove(e, index){
      this.$delete(this.skills.language, index)
      this.$store.commit('SET_SKILLS', this.skills)
      // e.target.parentNode.parentNode.parentNode.removeChild(e.target.parentNode.parentNode)
    },

    onChange() {
      this.$store.commit('SET_SKILLS', this.skills) 
    }
  },
}
</script>

<style lang="scss" scoped>
.language {
  &-skills {
    .form-control {
      max-width: 12rem;
      margin: 0 auto;
      text-align: center;
    }

    table {
      width: 100%;
      margin-bottom: 4rem;
      text-align: center;
      border: solid 1px #d1d3d4;

      td {
        position: relative;
        padding: 0.75rem 1rem;
        border-left: solid 1px #d1d3d4;
        // border-bottom: solid 1px #d1d3d4;
      }

      tfoot {
        td {
          border-top: solid 1px #d1d3d4;
        }
      }

      tbody {
        tr:first-child {
          td {
            padding-top: 2rem;
          }
        }

        tr:last-child {
          td {
            padding-bottom: 2rem;
          }
        }
      }

      th {
        text-align: center;
        color: #fff;
        font-size: 20px;
        padding: 1rem 0;
        background: #67c3e9;
        border: solid 1px #59b6dc;

        &:first-child {
          width: 30%;
        }
      }
    }
  }
  &-add {
    color: #0f4c98;
    font-size: 1.125rem;
    border: none;
    background: none;
    outline: none;
  }

  &-remove {
    color: #0f4c98;
    font-size: 1.125rem;
    border: none;
    background: none;
    outline: none;
  }
}
</style>
